import { SurveyJSON } from "Survey/types"

const json: SurveyJSON = {
  success: 'Færdig!',
  allowNewCustomer: true,
  errors: {
    required: 'Udfyld venligst dette'
  },
  locales: {
    dk: {
      nextButton: 'Fortsæt',
      nextButtonHint: 'tryk <b>Enter ↵</b>',
      submitButton: 'Indsend',
      textAreaHint: '<b>Shift ⇧</b> + <b>Enter ↵</b> to make a line break',
      invalidEmail: "Email adressen er ugyldig"
    }
  },
  defaultLocale: 'dk',
  items: [
    {
      type: 'custom',
      name: 'header',
      html: 'Velkommen til Revisor1s Afstemningstest for Reconciliation af Creditors and debitors for previous periods.  Skriv dit svar under hvert spørgsmål. Når du er færdig, trykker du blot på ‘færdig’ knappen, og så modtager vi automatisk dine svar. God fornøjelse!',
      buttonsAlign: 'left',
      buttons: ['next']
    },
    {
      type: 'input',
      name: 'name',
      title: 'Hvad er dit navn',
      required: true,
      placeholder: 'Jens Jensen'
    },
    {
      type: 'input',
      inputType: 'email',
      name: 'email',
      title: 'Hvad er din email adresse?',
      required: true,
      placeholder: 'email@email.com'
         },
          { 
      type: 'input',
      name: 'Hvornår_ligger_task_"reconcile_creditors_and_debitors_previous_periods"_i_forhold_til_“reconciliation_checked”_task?',
      title: 'Hvornår ligger task "reconcile_creditors_and_debitors_previous_periods" i forhold til “reconciliation_checked” task? ',
      required: true,
    },
          { 
      type: 'input',
      name: 'Hvad_er_formålet_med_"reconcile_creditors_and_debitors_previous_periods"?',
      title: 'Hvad er formålet med "reconcile_creditors_and_debitors_previous_periods"?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvilket_view_bruges_til_afstemningen?',
      title: 'Hvilket view bruges til afstemningen?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvilke_linjer_skal_ikke_afstemmes_i_reconciliation_new?',
      title: 'Hvilke linjer skal ikke afstemmes i reconciliation_new?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvordan_laves_et_match_i_Advanced_Reconciliation?',
      title: 'Hvordan laves et match i Advanced Reconciliation?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvad_skal_du_gøre,_hvis_der_ikke_findes_en_matchende_banktransaktion?',
      title: 'Hvad skal du gøre, hvis der ikke findes en matchende banktransaktion?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvordan_håndteres_åbne_poster_fra_tidligere_regnskabsår?',
      title: 'Hvordan håndteres åbne poster fra tidligere regnskabsår?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvad_gør_du,_hvis_banktransaktionen_findes_i_kontokortet_uden_bilagsnummer?',
      title: 'Hvad gør du, hvis banktransaktionen findes i kontokortet uden bilagsnummer?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvordan_afsluttes_tasken_korrekt?',
      title: 'Hvordan afsluttes tasken korrekt?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvorfor_er_det_vigtigt_at_denne_task_udføres,_før_mangellister_sendes_til_kunden?_Hvordan_håndteres_åbentstående_poster_der_ikke_kan_matches?',
      title: 'Hvorfor er det vigtigt at denne task udføres, før mangellister sendes til kunden? Hvordan håndteres åbentstående poster der ikke kan matches?',
      required: true,
    },
    { 
type: 'input', 
  name: 'Hvordan_håndteres_åbentstående_poster_der_ikke_kan_matches?', 
title: 'Hvordan_håndteres_åbentstående_poster_der_ikke_kan_matches?? ',
      required: true,
      },
    { 
      type: 'input',
      name: 'Hvorfor_er_det_vigtigt_at_afstemme_debitorer_og_kreditorer_fra_tidligere_perioder?',
      title: 'Hvorfor er det vigtigt at afstemme debitorer og kreditorer fra tidligere perioder?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvad_kan_konsekvensen_være,_hvis_debitorer/kreditorer_ikke_afstemmes_korrekt?',
      title: 'Hvad kan konsekvensen være, hvis debitorer/kreditorer ikke afstemmes korrekt?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvordan_påvirker_en_manglende_afstemning_af_debitorer/kreditorer_kundens_regnskab?_Svar:',
      title: 'Hvordan påvirker en manglende afstemning af debitorer/kreditorer kundens regnskab? Svar:',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvorfor_må_man_ikke_matche_direkte_på_bilag_fra_tidligere_regnskabsår?',
      title: 'Hvorfor må man ikke matche direkte på bilag fra tidligere regnskabsår?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvad_er_forskellen_på_en_debitor_og_en_kreditor_i_regnskabsmæssig_forstand?',
      title: 'Hvad er forskellen på en debitor og en kreditor i regnskabsmæssig forstand?',
      required: true,
    },
    { 
      type: 'input',
      name: 'Hvorfor_skal_man_være_opmærksom_på_samlebetalinger?',
      title: 'Hvorfor skal man være opmærksom på samlebetalinger?',
      required: true,
    },
    {
      type: 'custom',
      name: 'submit',
      html: '<blockquote>Tryk "indsend" for at sende os svarene.</blockquote>',
      buttons: ['submit']
    }
  ]
}

export default json
